import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import toast from 'utils/toast';

// 토스트 컨텍스트 생성
const ToastContext = createContext(null);

// 토스트 Provider
export function ToastProvider({ children }) {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'error'
  });

  const showToast = useCallback((message, severity = 'error') => {
    setSnackbar({ open: true, message, severity });
  }, []);

  const hideToast = useCallback((event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  }, []);

  // toast 이벤트 에미터 구독
  useEffect(() => {
    const unsubscribe = toast.subscribe(({ message, severity }) => {
      showToast(message, severity);
    });
    return unsubscribe;
  }, [showToast]);

  return (
    <ToastContext.Provider value={{ showToast, hideToast }}>
      {children}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={hideToast}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={hideToast}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
}

// 토스트 훅
export function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
}

export default ToastContext;

